import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import React, { useRef } from 'react';
import { CheckBoxContainer } from './styled';

interface CheckBoxProps {
  label?: string;
  onChange: (ref: React.MutableRefObject<undefined>) => any;
  className?: string;
  [key: string]: any;
}

const CheckBox = React.memo(({ label, onChange, className, ...props }: CheckBoxProps) => {
  const inputRef = useRef();
  return (
    <CheckBoxContainer className={className} onClick={() => onChange(inputRef)}>
      <input
        {...props}
        type="checkbox"
        ref={inputRef}
        onChange={() => onChange(inputRef)}
      />
      <Text size="14px" color={color.midgray} padding="0 4px">
        {label}
      </Text>
    </CheckBoxContainer>
  );
});

export default CheckBox;
